import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import TitleContainer from "../../LogoLinks/TitleContainer";
import LayoutContainer from "../../../components/LayoutsContainer";

import PortFolioItem from "./PortFolioItem";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "5vh 0vw",
    [theme.breakpoints.down("md")]: {
      padding: "1vh 0vw",
    },
  },
  aboutUsImage: {
    height: "50vh",
    width: "100%",
    objectFit: "contain",
  },
  TitleContainer: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(0),
    },
  },
  peopleContainer: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(1),
    },
  },
}));

const AboutUsLayout = ({ data }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LayoutContainer>
        <Grid container spacing={2}>
          <Grid item lg={12} container alignItems="flex-start">
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className={classes.TitleContainer}
            >
              <TitleContainer title={data.title} />
            </Grid>

            <Grid
              item
              spacing={2}
              container
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className={classes.peopleContainer}
            >
              {data?.data?.map((item, index) => {
                return (
                  <Grid item lg={2} md={3} sm={6} xs={6} key={index}>
                    <PortFolioItem data={item} />
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </LayoutContainer>
    </div>
  );
};
export default AboutUsLayout;
